import { useState } from 'react';
import { Button, Modal, Alert, Badge } from '../../components/ui';
import { reservarTurno } from '../../api/turnos';
import { formatFechaLarga, formatHora } from '../../utils/fechas';
import { money, coberturaTone, nombreSede } from './BuscarUtils';
import './Buscar.css';

export default function ModalConfirmarReserva({ turno, pacienteId, onCerrar, onReservado }) {
  const [reservando, setReservando] = useState(false);
  const [error, setError] = useState('');

  const confirmar = async () => {
    setReservando(true); setError('');
    try {
      await reservarTurno(pacienteId, turno.id);
      onReservado(turno);
    } catch (err) {
      setError(err.message);
    } finally {
      setReservando(false);
    }
  };

  const cerrar = () => { if (!reservando) { setError(''); onCerrar(); } };

  return (
    <Modal
      open={!!turno}
      onClose={cerrar}
      title="Confirmar reserva"
      description="Revisá los datos antes de confirmar."
      icon={
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
      }
      actions={
        <>
          <Button variant="secondary" onClick={cerrar} disabled={reservando}>Cancelar</Button>
          <Button variant="accent" onClick={confirmar} disabled={reservando}>
            {reservando ? 'Reservando…' : 'Confirmar reserva'}
          </Button>
        </>
      }
    >
      {turno && (
        <>
          <dl className="buscar-detail-grid">
            <div><dt>Fecha y hora</dt><dd>{formatFechaLarga(turno.fechaYHora)} · {formatHora(turno.fechaYHora)}</dd></div>
            <div><dt>Médico</dt><dd>{turno.medico?.nombre}</dd></div>
            <div><dt>Servicio</dt><dd>{turno.servicio?.nombre}</dd></div>
            <div><dt>Sede</dt><dd>{nombreSede(turno.sede)}</dd></div>
          </dl>
          <Alert tone="info">
            <div className="buscar-cost-row">
              <span>Cobertura</span>
              <Badge tone={coberturaTone(turno.tipoCobertura)} dot>{turno.tipoCobertura || 'según plan'}</Badge>
            </div>
            <div className="buscar-cost-row" style={{ marginTop: 8, fontWeight: 700 }}>
              <span>Costo final del turno</span>
              <span style={{ fontSize: '1.1rem' }}>{money.format(turno.costoEstimado ?? 0)}</span>
            </div>
          </Alert>
          {error && <div style={{ marginTop: 12 }}><Alert tone="danger" title="No pudimos reservar">{error}</Alert></div>}
        </>
      )}
    </Modal>
  );
}